<template>
    <div class="antialiased">
        <Sidebar />
        <div class="page">
            <Header :disabledSearch="false"></Header>


            <div class="content">
                <div class="container pos-relative">
                    <div class="page-header">
                        <div class="row d-flex justify-content-between">
                            <div class="col-auto">
                                <h2 class="page-title">Batch Update Toko</h2>
                                <button class="btn btn-outline-primary" v-html="ic('download') + ' Download Template'" @click="_downloadTemplate"></button>
                            </div>

                            <div class="col-auto" v-if="dataTokoUpdate.data.length <= 0">
                                <div class="alert alert-info">
                                <b> <i class="fe fe-info mr-1"></i> SYARAT UPLOAD!</b> <br />
                                Format file harus .xlsx atau .xls
                                </div>
                            </div>
                            <div class="col-auto" v-if="dataTokoUpdate.data.length > 0">
                                <div class="alert alert-info">
                                <b> <i class="fe fe-info mr-1"></i> CHECK FORM!</b> <br />
                                Pastikan semua data yang akan di Update
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="page-body" v-if="dataTokoUpdate.data.length <= 0"> 
                        <div class="frame-upload" @dragover.prevent @drop.prevent="_drop">
                            <div 
                                class="input-file"
                                :class="condition.isSubmit ? 'active' : ''"
                                @click="condition.isSubmit ? false : $refs.file.click()">

                                <transition name="slide-fade-y" >
                                    <div v-if="file.data != null">
                                        <div class="img">
                                            <span v-html="file.size"></span>
                                            <span v-html="file.size"></span>
                                            <img :src="asset('excel.png')" alt="icon-excel" />
                                        </div>
                                        <p v-html="file.name" class="mt-2"></p>
                                    </div>
                                </transition>

                                <input
                                    type="file"
                                    class="d-none"
                                    accept=".xlsx,.xls"
                                    ref="file"
                                    @change="_onFile"/>
                                    
                                <div v-if="file.data == null && !condition.hasUploaded">
                                    <div class="mb-3"><i class="fe fe-upload"></i></div>
                                    <div style="letter-spacing: 2px">
                                        UPLOAD FILE EXCEL <br/>
                                        ATAU DRAG & DROP DISINI
                                    </div>
                                </div>
                            </div>

                        </div>

                        <transition name="slide-fade-y">
                            <div class="btn-fly" v-if="file.data != null">
                                <h3 
                                    v-if="condition.isSubmit"
                                    class="text-center"
                                    v-html="form.time >= 60 ? parseInt(form.time / 60) + ' menit ' + (form.time - 60 * parseInt(form.time / 60)) + ' detik' : form.time + ' detik'"
                                    >
                                </h3>
                                <button 
                                    @click="_importListToko"
                                    :disabled="condition.isSubmit"    
                                    class="btn btn-primary btn-pill"
                                    v-html="condition.isSubmit ? spin()+' Mohon menunggu...' : 'IMPORT LIST TOKO'">
                                </button>
                            </div>
                        </transition>
                    </div>
                
                    
                    <transition name="slide-fade-y">
                        <Skeleton
                            v-if="this.form.loading"
                            type="table"
                            :length="10"
                            class="mt-3 bg-white"
                        />
                        <section class="page-body" v-if="dataTokoUpdate.data.length > 0 && !form.loading">
                            <div class="card" >
                                <div class="table-responsive overflow-auto" style="max-height: 680px;">
                                    <table class="table table-vcenter table-hover card-table table-striped table-control">
                                        <thead>
                                            <tr class="text-muted">
                                                <td class="pl-4">No</td>
                                                <td :key="i" class="text-capitalize" v-for="(header, i) in dataTokoUpdate.headers">
                                                    {{ header.replaceAll('_', ' ') }}
                                                </td>
                                                <td class="pl-4">Status</td>
                                                <td class=""></td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(toko ,index) in dataTokoUpdate.data" :key="index">
                                                <td>{{ index + 1 }}</td>
                                                <td :key="i" v-for="(header, i) in dataTokoUpdate.headers">
                                                        <input type="text" 
                                                        class="form-control" :class="toko.errors.includes(header) ? 'is-invalid' : ''"
                                                         v-model="toko.request[header]">
                                                </td>
                                                <td>
                                                    <span 
                                                        class="badge w-100"
                                                        :class="
                                                            toko.valid
                                                            ? 'bg-success'
                                                            : 'bg-danger'
                                                        "
                                                        v-html="toko.valid ? 'VALID' : 'TIDAK VALID'"
                                                    ></span>
                                                </td>
                                                <td class="p-0 pos-relative">
                                                    <div class="btn-group option center">
                                                        <button
                                                            class="btn btn-white btn-pill"
                                                            @click="_infoData(toko)"
                                                            v-html="ic('info')"
                                                        ></button>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </section> 
                    </transition>
                    <transition name="slide-fade-y" >
                        <div v-if="dataTokoUpdate.data.length > 0 && !this.form.loading" class="d-flex flex-row-reverse">
                            <button :disabled="form.isSubmit" @click="_updateData" class="btn btn-primary ml-2" :key="2">Update Data</button>
                            <button :disabled="form.isSubmit" @click="_checkData" class="btn btn-outline-primary ml-2" :key="1">Check Data</button>
                        </div>
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" src="./import-list-toko.scss" scoped/>
<script>
    import { mapState, mapActions  } from "vuex";
    import helper from "@/assets/js/helper.js";
    export default {
        name: "BatchUpdateToko",
        mixins: [helper],
        data() {
            return {
                file: {
                    name: null,
                    size: null,
                    data: null
                },
                condition:{
                    hasUploaded: false,
                    isSubmit: false,
                    isFinish: false,
                },
                form:{
                    time: 0,
                    loading: false,
                    isSubmit: false,
                    timeFinish: 0,
                    interval: null,
                    allowed: ["xlsx", "xls"],
                    primaryField: ['no_acc','cust_no','nama_tim']
                }
            }
        },
        computed: {
            ...mapState("toko",['dataTokoUpdate'])
        },
        methods: {
            ...mapActions("toko",['getListTokoUpdate','batchUpdateToko']),

            _drop(event){
                this._onFile(event, {files : event.dataTransfer.files})
            },
            _onFile(event, params){
                const file = params == null ? event.target.files[0] : params.files[0];
                if(this.form.allowed.indexOf(file.name.split(".").pop()) < 0){
                    this.toast("Format file tidak valid");
                    return;
                }

                if(typeof FileReader === "function"){
                    const reader = new FileReader();
                    setTimeout(
                        () => {
                            reader.onload = (event) => {
                                this.file.data = file;
                                this.file.name = file.name;
                                this.file.size = this.formatBytes(file.size);
                            };
                            this.condition.hasUploaded = true
                            reader.readAsDataURL(file);
                        },this.condition.hasUploaded ? 500 : 0
                    )
                } else {
                    this.toast("FileReader API not supported");
                }
            },

            async _importListToko(){
                this.condition.isSubmit = true
                let payload = new FormData()
                payload.append('file',this.file.data)

                let self = this.form;
                self.time = 1;
                self.timeFinish = 1;

                this.interval = setInterval(function () {
                    self.time = self.time + 1;
                    self.timeFinish = self.timeFinish + 1;
                }, 1000);

                try {
                    await this.getListTokoUpdate(payload)
                    clearInterval(this.interval);
                    this.form.loading = false
                    this.condition.isSubmit = false;
                    this.file.data = null;
                    this.condition.hasUploaded = false;
                    this.condition.isFinish = true;
                } catch (error) {
                    this.onError(error);
                    this.condition.isSubmit = false;
                    this.condition.isFinish = true;
                    clearInterval(this.interval);
                }
            },

            _infoData(dataToko){
                let textStatus = "Data toko ditemukan";
                let textField = "Format data sudah benar";
                if(!dataToko.response.valid){
                    textStatus = "Data toko tidak ditemukan" 
                    textField = "Mohon periksa kembali data unik toko"
                }
                if(dataToko.response.errors.length > 0){
                    let listError = dataToko.response.errors.toString()
                    textField = "Mohon periksa kembali data " + listError
                }
                this.$swal({
                    icon: 'warning',
                    title: textStatus,
                    text: textField,
                })
            },

            async _checkData(){
                this.form.loading = true
                this.form.isSubmit = true
                try {
                    await this.getListTokoUpdate({data: this.dataTokoUpdate.data})
                    this.form.loading = false
                    this.form.isSubmit = false
                } catch (error) {
                    this.form.loading = false
                    this.form.isSubmit = false
                    this.onError(error);
                }
            },
            _updateData(){
                try {
                    this.$swal.fire({
                        title: 'Peringatan',
                        text: "Data belum sepenuhnya Valid. Yakin ingin mengupdate?, hanya data toko yang valid saja akan terupdate.",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Yes, update it!'
                        }).then(async (result) => {
                        if (result.isConfirmed) {
                            this.form.isSubmit = true
                            await this.getListTokoUpdate({data: this.dataTokoUpdate.data})
                            await this.batchUpdateToko(this.dataTokoUpdate.data)
                            this.form.isSubmit = false
                        }
                    })
                } catch (error) {
                    this.onError(error);
                }
            },
            _downloadTemplate(){
                let data_excel = [{
                    "id": '',
                    "no_acc": 'Wajib diisi jika id kosong',
                    "cust_no": 'Wajib diisi jika id kosong',
                    "nama_tim": 'Wajib diisi jika id kosong',
                    "nama_tim_update": 'Peruabahan tim',
                    "nama_perusahaan": 'Wajib isi jika ingin mengubah depo',
                    "nama_depo": 'Wajib isi nama_perusahaan jika ingin merubah Depo',
                    "nama_gudang": '',
                    "gudang_retur": '',
                    "nama_kelurahan": '',
                    "nama_toko": '',
                    "tipe": 'tipe = tipe_outlet',
                    "tipe_3": 'tipe_3 = outlet_note',
                    "tipe_harga": 'Ex: RBP',
                    "pemilik": '',
                    "kode_mars": '',
                    "telepon": '',
                    "alamat": '',
                    "lock_order": '',
                    "gps": '',
                    "latitude": '',
                    "longitude": '',
                    "kode_pos": '',
                    "kode_eksklusif": '',
                    "k_t": 'Ketentuan toko Credit or Tunai',
                    "top": '',
                    "limit": '',
                    "minggu": 'diisi dengan Ex: 1,1&3',
                    "hari": '',
                    "npwp": '',
                    "status_ppn": '',
                    "nama_pkp": '',
                    "alamat_pkp": '',
                    "no_ktp": '',
                    "nama_ktp": '',
                    "alamat_ktp": '',
                    "tags": 'Isi dengan "," jika lebih dari 1 tag, Ex = pasar,denpasar',
                }]
                this.createExcel({
                    data: data_excel,
                    filename: "template_update_batch_toko"
                });
                this.$swal.fire({
                    title: 'Information',
                    text: "Hapus beberapa header yang tidak diperlukan untuk update data Toko, kecuali header No Acc, Cust No dan Nama Tim",
                    icon: 'info',
                })
            }

        },
    }
</script>
